 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/text/Title'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
 import TEXTDEDICATION from '@/components/text/Dedication'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXTINTRODUCTION from '@/components/text/Introduction'
 import TEXTCHAPTER1 from '@/components/text/Chapter1'
 import TEXTCHAPTER2 from '@/components/text/Chapter2'
 import TEXTCHAPTER3 from '@/components/text/Chapter3'
 import TEXTCHAPTER4 from '@/components/text/Chapter4'
 import TEXTCHAPTER5 from '@/components/text/Chapter5'
 import TEXTCHAPTER6 from '@/components/text/Chapter6'
 import TEXTCHAPTER7 from '@/components/text/Chapter7'
 import TEXTCHAPTER8 from '@/components/text/Chapter8'
 import TEXTCHAPTER9 from '@/components/text/Chapter9'
 import TEXTCHAPTER10 from '@/components/text/Chapter10'
 import LOVE_2 from '@/components/love_2'
 import TEXTBACKMATTER from '@/components/text/Backmatter'
 import TEXTBACKMATTER1 from '@/components/text/Backmatter1'
 import TEXTACKNOWLEDGMENTS from '@/components/text/Acknowledgments'
 import TEXTABOUTTHEAUTHOR from '@/components/text/Abouttheauthor'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/Introduction",
 			"name" : "text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/text/Chapter1",
 			"name" : "text/Chapter1",
 			"component" : TEXTCHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js